import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from 'react';
import { FaFilter, FaRegTrashAlt } from 'react-icons/fa';
import { Toolbar, } from 'react-science/ui';
import { CounterLabel } from '../../elements/CounterLabel';
import { PreferencesButton } from '../../elements/PreferencesButton';
import PanelHeader from './PanelHeader';
const styles = {
    leftContainer: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
    },
};
function isCustomToolbarItem(item) {
    return 'component' in item;
}
export function formatCounterLabel(counter, total) {
    if (counter !== undefined &&
        total !== undefined &&
        counter >= 0 &&
        total >= 0 &&
        counter !== total) {
        return `[ ${counter}/${total} ]`;
    }
    if (total !== undefined) {
        return `[ ${total} ]`;
    }
    return '';
}
function DefaultPanelHeader(props) {
    const { total, counter, onDelete, deleteToolTip = 'Delete', onFilter, filterToolTip = '', children, onSettingClick, disableDelete = false, style = {}, className = '', rightButtons = [], leftButtons = [], } = props;
    const [isFiltered, setFilterStatus] = useState(false);
    function handleFilter() {
        setFilterStatus((previousValue) => !previousValue);
        onFilter?.();
    }
    return (_jsxs(PanelHeader, { style, className, children: [_jsxs("div", { style: styles.leftContainer, children: [_jsxs(Toolbar, { children: [onDelete && (_jsx(Toolbar.Item, { id: "delete-button", onClick: onDelete, tooltip: deleteToolTip, icon: _jsx(FaRegTrashAlt, {}), intent: "danger", disabled: !total || disableDelete })), onFilter && (_jsx(Toolbar.Item, { id: "filter-button", onClick: handleFilter, tooltip: filterToolTip, active: isFiltered, icon: _jsx(FaFilter, {}) })), mapToolbarButtons(leftButtons)] }), children] }), _jsx(Toolbar, { children: mapToolbarButtons(rightButtons) }), _jsx(CounterLabel, { value: formatCounterLabel(counter, total) }), onSettingClick && (_jsx(PreferencesButton, { tooltip: "Preferences", onClick: onSettingClick }))] }));
}
function mapToolbarButtons(buttons) {
    return buttons.map((props, index) => isCustomToolbarItem(props) ? (
    // eslint-disable-next-line react/no-array-index-key
    _jsx(Fragment, { children: props.component }, `${index}`)) : (_jsx(Toolbar.Item, { ...props }, props?.id || `${index}`)));
}
export default DefaultPanelHeader;
